<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <div class="card-title">Importações</div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12 centered">
                                <h3>Bem-vindo(a) ao Pesquisa!</h3>
                                <h5>Para podermos começar, faça um upload de uma planilha para que possamos cadastrar os usuários da sua empresa</h5>
                            </div>
                        </div>
                        <div class="row mt-5">
                            <div class="col-md-4 offset-md-4">
                                <a
                                    :href="$store.getters.url + 'layouts/importUsersTrial'"
                                    target="_blank"
                                    class="btn btn-normal btn-block"
                                >Baixar Modelo de Excel</a>
                            </div>
                        </div>
                        <div class="row mt-5">
                            <div class="col-md-4 offset-md-4">
                                <div class="form-group">
                                    <label>Importe aqui sua planilha preenchida, conforme o modelo acima</label>
                                    <input
                                        id="import-file"
                                        type="file"
                                        class="form-control"
                                        @change="importFile()"
                                    />
                                </div>
                            </div>
                        </div>

                        <div class="row mt-4" v-show="error">
                            <div class="col-md-6 offset-md-3">
                                <div class="alert alert-danger" role="alert">{{ error }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            error: ""
        };
    },
    methods: {
        importFile: function() {
            const self = this;
            const api = self.$store.state.api + "import/importUsersTrial";
            self.error = "";

            const fd = new FormData();
            const file = document.getElementById("import-file").files[0]
            if(file){
                fd.append("file", file);
            } else return

            self.$http
                .post(api, fd)
                .then(response => {
                    const apiStep =
                        self.$store.state.api +
                        "researchfirststeps/stepCompleted";
                    self.$http
                        .post(apiStep, {
                            step: 'importation'
                        })
                        .then(response => {
                            self.$message(
                                "Sucesso",
                                "Dados importados com sucesso",
                                "success"
                            );
                            self.$router.push("/");
                        })
                        .catch(error => {
                            self.$message("Erro", error.response.data, "error");
                        });
                })
                .catch(error => {
                    document.getElementById("import-file").value = ''
                    self.error = error.response.data.message;
                    if(!error.response.data.message){
                        self.$message('Erro', 'Ocorreu um erro. Por favor, verifique se o tipo de arquivo é XLSX e se todos os dados estão preenchidos de forma correta', 'error');
                    }
                });
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/components/FirstSteps/Import.vue